import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './header.scss';
import LogoMiBanco from '@assets/icons/logo-mi-banco.svg';
import { Link } from 'react-router-dom';
import { useIsAttentionSchedule, useObtainAttentionSchedule } from '../../../utils/utils';
import InfoIcon from '@assets/images/infoIcon.webp';
import BankIcon from '@assets/icons/bank-note.svg';
import { useState, useEffect } from 'react';
import { VARIABLES } from '../../../assets/constants/configVariables';
const Header = () => {
    const isAvailable = useIsAttentionSchedule();
    const [startHour, endHour] = useObtainAttentionSchedule();
    const [styles, setStyles] = useState({
        backgroundColor: '#FFFFFF',
        textColor: '#3FB1E2',
        filter: 'none',
    });
    useEffect(() => {
        const timer = setTimeout(() => {
            setStyles({
                backgroundColor: '#3FB1E2',
                textColor: '#FFFFFF',
                filter: 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7485%) hue-rotate(189deg) brightness(103%) contrast(103%)',
            });
        }, 1000);
        return () => clearTimeout(timer);
    }, []);
    const redirectToHomeMibanco = () => {
        window.location.replace("https://www.mibanco.com.pe/");
    };
    return (_jsxs(_Fragment, { children: [isAvailable && VARIABLES.PROMO && _jsxs("div", { className: 'top-banner', style: {
                    backgroundColor: styles.backgroundColor,
                    transition: 'background-color 800ms ease',
                }, children: [_jsx("img", { src: BankIcon, alt: "info_icon", className: 'top-banner__image', style: {
                            filter: styles.filter,
                            transition: 'filter 800ms ease',
                        } }), _jsxs("div", { className: 'top-banner__textColumnDesktop', style: {
                            color: styles.textColor,
                            transition: 'color 800ms ease',
                        }, children: [_jsxs("span", { children: [_jsx("span", { style: { fontWeight: 'bold' }, children: `¡Gana S/ 30,000` }), ' abriendo tu cuenta ahora!'] }), _jsxs("span", { children: [_jsx("span", { className: 'top-banner__textColumnDesktop_textTerms', children: `Aplican` }), ` `, _jsx("span", { className: 'top-banner__textColumnDesktop_textTermsUndeline', children: `términos y condiciones` })] })] }), _jsxs("div", { className: 'top-banner__textColumnMobile', style: {
                            color: styles.textColor,
                            transition: 'color 800ms ease',
                        }, children: [_jsxs("span", { children: [_jsx("span", { children: `¡Abre tu cuenta Mibanco y` }), _jsx("span", { style: { fontWeight: 'bold' }, children: ' gana S/ 30,000!' })] }), _jsxs("span", { children: [_jsx("span", { className: 'top-banner__textColumnMobile_textTerms', children: `Aplican` }), ` `, _jsx("span", { className: 'top-banner__textColumnMobile_textTerms', style: { fontWeight: 'bold' }, children: `términos y condiciones` })] })] })] }), !isAvailable &&
                _jsxs("div", { className: 'top-banner', children: [_jsx("img", { src: InfoIcon, alt: "info_icon", className: 'top-banner__image' }), _jsxs("div", { className: 'top-banner__text', children: [_jsx("span", { style: { fontWeight: 'bold' }, children: `Nuestro horario de atención es de ${startHour} a ${endHour} ` }), _jsx("span", { children: `Continuaremos trabajando para darte un mejor servicio.` })] })] }), _jsx("div", { className: 'header_component', children: _jsx("div", { className: 'header_component_container', children: _jsx(Link, { to: "/", children: _jsx("img", { src: LogoMiBanco, alt: "logo-mibanco" }) }) }) })] }));
};
export default Header;
